export const APP_VERSION = 22;
export default APP_VERSION;
